module.exports = __webpack_public_path__ + "img/calendar2_pl.0b674340.svg";